export default "__VITE_ASSET__041c6a45__"